import { h } from '@/lib/dom';

export interface FormFieldProps {
  label: string;
  hint?: string;
  error?: string;
  required?: boolean;
  htmlFor?: string;
  children: Node;
}

export function FormField(props: FormFieldProps): HTMLElement {
  return h('div', { class: 'form-field' }, [
    h('label', {
      class: 'form-label',
      for: props.htmlFor,
    }, [
      props.label,
      props.required ? h('span', { class: 'required', 'aria-hidden': 'true' }, '*') : null,
    ]),
    props.children,
    props.hint && !props.error ? h('span', { class: 'form-hint' }, props.hint) : null,
    props.error ? h('span', { class: 'form-error', role: 'alert' }, props.error) : null,
  ]);
}
